module.exports = __webpack_public_path__ + "media/images/photography/ty-products-e912453f259921c34c5fbb48da713f3e.jpg";